import { notification, Spin } from 'antd'
import ReactDOM from 'react-dom'
import React from 'react'

const offlineNotificationKey = 'offlineAlert'

// Function to toggle offline state and manage loader
const toggleOfflineState = (isOffline) => {
  const appRoot = document.getElementById('root')
  if (appRoot) {
    appRoot.style.filter = isOffline ? 'blur(3px)' : 'none' // Blur effect
    appRoot.style.pointerEvents = isOffline ? 'none' : 'auto' // Disable/Enable interactions
    
    // Handle Ant Design Spin loader
    if (isOffline) {
      // Create container for Spin if it doesn't exist
      if (!document.getElementById('offline-loader-container')) {
        const loaderContainer = document.createElement('div')
        loaderContainer.id = 'offline-loader-container'
        loaderContainer.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 9999;
        `
        document.body.appendChild(loaderContainer)
        
        // Render Ant Design Spin component
        ReactDOM.render(
          <Spin size="large" />,
          loaderContainer
        )
      }
    } else {
      // Remove loader when back online
      const loaderContainer = document.getElementById('offline-loader-container')
      if (loaderContainer) {
        ReactDOM.unmountComponentAtNode(loaderContainer)
        loaderContainer.remove()
      }
    }
  }
}

window.addEventListener('offline', () => {
  notification.warning({
    key: offlineNotificationKey,
    message: 'Network Disconnected',
    description: 'You are offline. Please check your internet connection.',
    placement: 'topRight',
    duration: 0 // Keeps it open until manually closed
  })
  
  toggleOfflineState(true) // Apply blur and show loader
})

window.addEventListener('online', () => {
  notification.destroy() // Remove offline notification
  notification.success({
    message: 'Back Online',
    description: 'Your internet connection is restored.',
    placement: 'topRight'
  })
  
  toggleOfflineState(false) // Remove blur and loader
})